import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import LinkPropType from 'proptypes/LinkPropType';
import * as styles from './styles/styles.module.scss';

const Dropdown = ({ links }) =>
  links.map(link => (
    <a
      key={link.label}
      href={link.linkPath}
      title={link.label}
      className={styles.dropdownLink}
      data-testid={link.label}
      {...(link.openInNewWindow ? { target: '_blank' } : {})}
    >
      {link.label}
    </a>
  ));

const LinkDropdown = ({ label, linkPath, onClick, dropdown = [] }) => {
  const [isOpen, toggleOpen] = useState(false);

  if (dropdown.length > 0) {
    return (
      <>
        <button
          className={styles.buttonHeader}
          aria-expanded={isOpen}
          onClick={() => toggleOpen(!isOpen)}
          type="button"
          data-testid="linkDropdown-buttonHeader"
        >
          <span data-testid={label}>{label}</span>
          <ExpandMore className={`${styles.expandMore} ${isOpen ? styles.expandMoreIsOpen : ''}`} />
        </button>
        <Collapse in={isOpen} collapsedHeight="0px" elementtype="div">
          <Dropdown links={dropdown} />
        </Collapse>
      </>
    );
  }

  // thinking about moving ref replacement here
  const href = linkPath;

  return (
    <a className={styles.linkHeader} title={label} href={href} onClick={() => onClick?.()}>
      {label}
    </a>
  );
};

LinkDropdown.defaultProps = {
  dropdown: [],
  linkPath: null,
  onClick: null
};

LinkDropdown.propTypes = {
  dropdown: PropTypes.arrayOf(LinkPropType),
  label: PropTypes.string.isRequired,
  linkPath: PropTypes.string,
  onClick: PropTypes.func
};

export default LinkDropdown;
